import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "dot"]

  connect() {
    this.onScroll = this.#sync.bind(this)
    if (this.hasGridTarget) this.gridTarget.addEventListener("scroll", this.onScroll, { passive: true })
    this.#sync()
  }

  disconnect() {
    if (this.hasGridTarget) this.gridTarget.removeEventListener("scroll", this.onScroll)
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    const card = this.gridTarget.children[index]
    if (!card) return
    const left = card.offsetLeft - (this.gridTarget.clientWidth - card.clientWidth) / 2
    this.gridTarget.scrollTo({ left, behavior: "smooth" })
  }

  #sync() {
    if (!this.hasGridTarget || !this.hasDotTarget) return
    const center = this.gridTarget.scrollLeft + this.gridTarget.clientWidth / 2
    let activeIndex = 0
    let bestDistance = Infinity
    Array.from(this.gridTarget.children).forEach((card, index) => {
      const cardCenter = card.offsetLeft + card.clientWidth / 2
      const distance = Math.abs(cardCenter - center)
      if (distance < bestDistance) {
        bestDistance = distance
        activeIndex = index
      }
    })
    this.dotTargets.forEach((dot, index) => dot.classList.toggle("is-active", index === activeIndex))
  }
}
